<mono-common-back-to-navigation-bar
  data-test="lmw-base-my-learning-home-back-to-home-bar-top"
  [linkText]="mobileBackButtonText"
  linkTo="/"
  position="back-to-navigation__top"
></mono-common-back-to-navigation-bar>
<main
  id="content"
  #content
  class="browse browse--my-learning"
  aria-describedby="ariaMainHeaderId"
>
  <div class="grid-container">
    <div class="grid-x">
      <div class="cell">
        <div
          class="flex-container align-justify browse--my-learning__header-wrapper"
        >
          <h1
            class="margin-0"
            id="ariaMainHeaderId"
          >
            {{ myLearningCms?.data?.attributes?.title }}
          </h1>
          <button
            (click)="printSummary()"
            type="button"
            class="button clear button--icon-on-right underline bold-text padding-right-0 browse__print"
          >
            <span>{{ myLearningCms?.data?.attributes?.printSummary }}</span>
            <svg
              class="icon icon--print icon--primary icon--material"
              viewBox="0 0 24 24"
            >
              <use xlink:href="#icon-print" href="#icon-print"></use>
            </svg>
          </button>
        </div>
        <h2 class="normal-text-weight">
          {{ translate("Progress summary for " + userFullName) | async }}
        </h2>
        <p
          class="lead"
        >
        {{ myLearningCms?.data?.attributes?.description }}
        </p>
      </div>
    </div>
  </div>
  <div class="grid-container browse__list-container browse__list-container--my-learning">
    <div *ngIf="!showSubjectsList" class="loader-background" role="alert" data-test="lmw-base-my-learning-home-loader">
      <div class="loader">
        <div class="loader__graphic" aria-hidden="true">
          <mono-common-loading-animation></mono-common-loading-animation>
        </div>
        <div class="loader__text">
          {{ myLearningCms?.data?.attributes?.loadingLearning }}
        </div>
      </div>
    </div>
    <ul class="no-bullet grid-x" *ngIf="showSubjectsList" data-test="lmw-base-my-learning-home-list">
        <li
          class="cell small-12 medium-6 padding-bottom-1"
          *ngFor="let subject of subjects; let i = index"
        >
          <lmw-common-subject-topic-link-button
            [text]="subject.title"
            [slug]="'../' + browseAllSubjectsBasePath + '/' + subject.sk"
            type="my-learning"
            iconColour="secondary-dark"
            [completed]="allSubjectsAndTopicInfo[i].subjectCompleted"
          >
          </lmw-common-subject-topic-link-button>
          <mono-common-progress-bar
            [showProgressBar]="true"
            [totalSteps]="allSubjectsAndTopicInfo[i].totalTopicsInSubject"
            [currentStep]="allSubjectsAndTopicInfo[i].topicsCompletedInSubject"
            [showProgressPercentage]="true"
            [language]="language"
          ></mono-common-progress-bar>
          <div
            class="browse--my-learning__metadata flex-container align-middle"
          >
            <p
              *ngIf="allSubjectsAndTopicInfo[i].latestTopicUpdatedDate"
              class="margin-bottom-0"
            >
              {{ translate("Latest topic completed on " + allSubjectsAndTopicInfo[i].latestTopicUpdatedDate) | async }}
            </p>
            <p
              *ngIf="!allSubjectsAndTopicInfo[i].latestTopicUpdatedDate"
              class="margin-bottom-0"
            >
              {{ translate("No topics completed") | async }}
            </p>
          </div>
        </li>
    </ul>
  </div>
</main>
<mono-common-back-to-navigation-bar
  data-test="lmw-base-my-learning-home-back-to-home-bar-bottom"
  [linkText]="mobileBackButtonText"
  linkTo="/"
  position="back-to-navigation__bottom"
></mono-common-back-to-navigation-bar>
